export default function ModalBackdrop({ onCancled }) {
  return <div className="backdrop" onClick={() => onCancled(null)} />;
}
